// Generated by scripts/sync-category-search.js.
// Shared category search implementation (client copies generated by sync script).


function normalizeCategoryQuery(value) {
  return String(value || '').normalize('NFKC').toLowerCase()
    .replace(/[\u200b-\u200d\ufeff]/g, '')
    .replace(/[^\p{L}\p{M}\p{N}]+/gu, ' ').trim().replace(/\s+/g, ' ');
}
function spellingKey(value) {
  return normalizeCategoryQuery(value).replace(/([a-z])\1+/g, '$1').replace(/centre/g, 'center');
}
function distance(a, b) {
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const next = [i];
    for (let j = 1; j <= b.length; j++) next[j] = Math.min(next[j - 1] + 1, prev[j] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    prev = next;
  }
  return prev[b.length];
}
function categorySearchScore(row, input) {
  const q = normalizeCategoryQuery(input);
  if (!q) return 0;
  const name = normalizeCategoryQuery(row.label || row.name_en || row.name);
  const te = normalizeCategoryQuery(row.telugu_name || row.teluguName || row.name_te);
  const raw = row.search_aliases || row.searchAliases || [];
  const aliases = (Array.isArray(raw) ? raw : []).map(normalizeCategoryQuery).filter(Boolean);
  if (name === q) return 0;
  if (te && te === q) return 1;
  if (aliases.includes(q)) return 2;
  const terms = [name, te, ...aliases].filter(Boolean);
  if (terms.some(t => t.startsWith(q))) return 3;
  if (terms.some(t => t.includes(q))) return 4;
  if (/^[a-z ]{4,}$/.test(q)) {
    const key = spellingKey(q);
    const max = key.length >= 9 ? 2 : 1;
    if (terms.some(t => {
      if (!/^[a-z ]+$/.test(t)) return false;
      const sk = spellingKey(t);
      // Same start keeps potter/blacksmith (kummari/kammari) from colliding.
      if (sk.slice(0, 2) !== key.slice(0, 2)) return false;
      return Math.abs(sk.length - key.length) <= max && distance(key, sk) <= max;
    })) return 5;
  }
  return Infinity;
}
function searchCategories(rows, query) {
  return rows.map((row, i) => ({ row, i, score: categorySearchScore(row, query) }))
    .filter(hit => Number.isFinite(hit.score)).sort((a, b) => a.score - b.score || a.i - b.i).map(hit => hit.row);
}
export { normalizeCategoryQuery, categorySearchScore, searchCategories };
